import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=f0ca75f0&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=f0ca75f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ca75f0",
  null
  
)

export default component.exports